import ActivityElement from 'components/activity-element/activity-element';

const ActivityPage = () => {
  return <ActivityElement />;
};

export default ActivityPage;
